export const dateOptions: Intl.DateTimeFormatOptions = {
  month: "2-digit",
  day: "2-digit",
  year: "numeric",
}

/*
 * this converts a Date to a localeDateString
 */
export function getLocaleDateStringFromDate(language: string, date: Date): string {
  const formatter = new Intl.DateTimeFormat(
    language,
    dateOptions,
  )

  return formatter.format(date)
}
